if (!customElements.get('mh-payment-label')) {
  customElements.define('mh-payment-label', class extends HTMLElement {
    connectedCallback() {
      const translate = () => {
        const label = this.dataset.label;
        if (!label) return;
        this.querySelectorAll('.shopify-payment-button__more-options').forEach(link => {
          if (link.textContent.trim() !== label) link.textContent = label;
          if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
        });
      };
      this.labelObserver = new MutationObserver(translate);
      this.labelObserver.observe(this, {childList: true, subtree: true, characterData: true});
      translate();
    }
    disconnectedCallback() {
      this.labelObserver?.disconnect();
    }
  });
}
